import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetDealershipLocationQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetDealershipLocationQuery = { __typename?: 'query_root', customers_by_pk?: { __typename?: 'customers', id: number, location?: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null } | null } | null };


export const GetDealershipLocationDocument = gql`
    query getDealershipLocation($customerId: bigint!) {
  customers_by_pk(id: $customerId) {
    id
    location {
      id
      name
      address
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetDealershipLocationQuery__
 *
 * To run a query within a React component, call `useGetDealershipLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealershipLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealershipLocationQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetDealershipLocationQuery(baseOptions: Apollo.QueryHookOptions<GetDealershipLocationQuery, GetDealershipLocationQueryVariables> & ({ variables: GetDealershipLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDealershipLocationQuery, GetDealershipLocationQueryVariables>(GetDealershipLocationDocument, options);
      }
export function useGetDealershipLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDealershipLocationQuery, GetDealershipLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDealershipLocationQuery, GetDealershipLocationQueryVariables>(GetDealershipLocationDocument, options);
        }
// @ts-ignore
export function useGetDealershipLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDealershipLocationQuery, GetDealershipLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetDealershipLocationQuery, GetDealershipLocationQueryVariables>;
export function useGetDealershipLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDealershipLocationQuery, GetDealershipLocationQueryVariables>): Apollo.UseSuspenseQueryResult<GetDealershipLocationQuery | undefined, GetDealershipLocationQueryVariables>;
export function useGetDealershipLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDealershipLocationQuery, GetDealershipLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDealershipLocationQuery, GetDealershipLocationQueryVariables>(GetDealershipLocationDocument, options);
        }
export type GetDealershipLocationQueryHookResult = ReturnType<typeof useGetDealershipLocationQuery>;
export type GetDealershipLocationLazyQueryHookResult = ReturnType<typeof useGetDealershipLocationLazyQuery>;
export type GetDealershipLocationSuspenseQueryHookResult = ReturnType<typeof useGetDealershipLocationSuspenseQuery>;
export type GetDealershipLocationQueryResult = Apollo.QueryResult<GetDealershipLocationQuery, GetDealershipLocationQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobileService/queries/getDealershipLocation.query.gql}
 */
export async function getDealershipLocation(
  variables: GetDealershipLocationQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDealershipLocationQuery['customers_by_pk']>
export async function getDealershipLocation(
  variables: GetDealershipLocationQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDealershipLocationQuery>
export async function getDealershipLocation(
  variables: GetDealershipLocationQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDealershipLocationQuery['customers_by_pk'] | GetDealershipLocationQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDealershipLocationQuery>(
    GetDealershipLocationDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers_by_pk
}